<script>
  import ContactsBackgroundIcons from "./ContactsBackgroundIcons.svelte";

  import { onMount } from "svelte";

  import { navigationStore } from "../../stores/navigationStore";
  import MediaQuery from "../../components/MediaQuery.svelte";
  import BgIconsMobile from "./Mobile/BgIconsMobile.svelte";

  export let header = "";
  export let text = "";

  let scrollY, scrollMaxY;

  $: if (scrollY + 60 > scrollMaxY) {
    navigationStore.changeActiveItem("contacts");
  }

  $: if (scrollMaxY - scrollY > 100 && $navigationStore.contacts) {
    navigationStore.changeActiveItem("features");
  }

  onMount(() => {
    scrollMaxY =
      window.scrollMaxY ||
      document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
  });
</script>

<svelte:window bind:scrollY />

<section id="contacts">
  <h1>{header}</h1>
  <p>{text}</p>

  <MediaQuery query="(max-width: 1280px)" let:matches>
    <!-- Mobile -->
    {#if matches}
      <div class="bg-icons-wrapper">
        <BgIconsMobile />
      </div>
    {/if}
  </MediaQuery>
  <MediaQuery query="(min-width: 1281px)" let:matches>
    <!-- Desktop -->
    {#if matches}
      <div class="bg-icons-wrapper">
        <ContactsBackgroundIcons />
      </div>

      <div class="bg-filter">
        <img
          loading="lazy"
          src="./assets/images/contacts_bg_filter.webp"
          alt="background filter"
        />
      </div>
    {/if}
  </MediaQuery>
</section>

<style>
  section {
    position: relative;
    width: 1440px;
    height: 631px;

    left: -32px;
    top: 355px;

    background-color: rgba(230, 237, 246, 1);
  }

  .bg-icons-wrapper {
    position: absolute;

    left: 294px;
    top: 100px;
  }

  h1 {
    position: absolute;
    white-space: nowrap;
    width: 634px;

    left: 403px;
    top: 230px;

    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 65px;

    /* identical to box height */
    text-align: center;

    color: #5666ed;
  }

  p {
    position: absolute;
    max-width: 370px;

    left: 527px;
    top: 270px;

    margin-top: 67px;

    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 170%;

    /* or 34px */
    text-align: center;

    color: #060606;
  }

  @media (max-width: 1280px) {
    /* Phones and Tablets*/

    section {
      width: 100%;
      height: 544px;
      left: 0;

      display: flex;
      flex-direction: column;
      align-items: center;
    }

    h1 {
      position: static;
      max-width: 300px;
      white-space: initial;
      font-size: 42px;
      margin-top: 167px;
    }
    p {
      position: static;
      margin-top: 14px;
    }

    .bg-icons-wrapper {
      position: relative;

      left: 0;
      top: -276px;
    }
  }
</style>
